'use client';
import { useContext } from 'react';
import { useTranslation } from '../../hooks/use-translation';
import CategoryPageContext from '../../context/category-page-context';
import React from 'react';
import { BreadCrumbItem } from './breadcrumb-item';

// -----------------------------------------------------------------------------
export const BreadCrumbs = (): JSX.Element => {
  const { categoryPage, basePath } = useContext(CategoryPageContext);
  const { t } = useTranslation();

  if (!categoryPage) {
    return <></>;
  }

  if (categoryPage?.name === 'appstore') {
    return <></>;
  }

  return (
    <nav aria-label='Breadcrumb' className='breadcrumb'>
      <ol>
        <BreadCrumbItem path='/appstore' text={t('home')} hasNext={true} />
        {basePath && basePath === 'browseByGame' && categoryPage.name === 'View-all' && (
          <BreadCrumbItem path='' text={t('All Games')} hasNext={false} />
        )}

        {basePath && basePath === 'browseByGame' && categoryPage.name !== 'View-all' && (
          <>
            <BreadCrumbItem path='/browse-by-game/view-all' text={t('All Games')} hasNext={true} />
            <BreadCrumbItem path='' text={categoryPage.name} hasNext={false} />
          </>
        )}

        {basePath && basePath === 'apps' && (
          <BreadCrumbItem path='' text={categoryPage.name} hasNext={false} />
        )}
      </ol>
    </nav>
  );
};
